import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import moment from 'moment';
import { debounce, isEmpty } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';

import BobFilterComponent from '../../../components/BobFilterComponent';
import ClientsTable from './ClientsTable';
import EquipmentTable from './EquipmentTable';
import EnergyTable from './EnergyTable';
import SitesTable from './SitesTable';
import SystemsTable from './SystemsTable';
import BobActionMenu from '../../../components/BobActionMenu';
import BobModal from '../../../components/BobModal';
import FilterChip from '../../../components/FilterChip';
import ServiceRequestList from '../ServiceManagement/ServiceRequestList';
import HealthMonitorTable from '../HealthMonitorTable/HealthMonitorTable';
import { getActiveTabName } from '../Navigation/NavigationHelper';
import SearchInput from '../../Global/SearchInput';
import TotalsPanel from '../../../components/TotalsPanel';
import SchedulerFilter from '../ScheduleBoard/SchedulerFilter';
import TabViewSelector from '../../../components/TabViewSelector';
import SchedulerDashboard from '../ScheduleBoard/SchedulerDashboard';
import NavModal from '../Modals/NavModal';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import ExportDataModal from '../Modals/ExportDataModal';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import {getTimeZoneAbbr} from '../../../helpers/timezones';
import queryString from 'query-string';

import { withRouter } from 'react-router-dom';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';

import {
    renderChip,
    renderFilter,
    removeFilter
} from '../../../helpers/tableContainerHelper';

import * as ConfigurationActions from '../../../actions/configurationActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './TableContainer.module.css';
import { setPageTitle } from '../../../helpers/auth';
//import FormulaBuilder from '../FormulaBuilder/FormulaBuilder';

const TABNAMES = {
    'Client':    dashboardContent.client,
    'Site':      dashboardContent.sites,
    'Equipment': dashboardContent.equipment,
    'System':    dashboardContent.systems,
    'Schedule':  dashboardContent.schedule
};

const TableContainer = ({
    activeNavCompany,
    activeTab,
    buildingTypes,
    businessTypes,
    cardScores,
    clientFilters,
    clientsMeta,
    companyApplications,
    dashboardIsCurrentTimeStamp,
    equipmentFilters,
    equipmentMeta,
    equipmentTypes,
    exportTableData,
    fetchAllConfigurations,
    history,
    healthMonitorFilters,
    isShowExportModal,
    issueTypes,
    setActiveTab,
    setClientFilters,
    setCompanyTabIndex,
    setEquipmentFilters,
    setSiteFilters,
    setSystemFilters,
    setHealthMonitorFilters,
    setWorkBookMode,
    siteFilters,
    sitesMeta,
    systemFilters,
    systemsMeta,
    systemTypes,
    userId,
    workbookModeEnabled,
    ...props
}) => {
    const [createSiteModalOpen, handleToggleCreateSiteModal] = useState(false);
    const [createEquipmentModalOpen, handleToggleCreateEquipmentModal] = useState(false);
    const [createClientModalOpen, handleToggleCreateClientModal] = useState(false);
    const [editClientModalOpen, handleToggleEditClientModal] = useState(false);
    const [subscribeToAlertsModalOpen, handleToggleSubscribeToAlertsModal] = useState(false);
    const [subscribeToAlertsSiteModalOpen, handleToggleSubscribeToSiteAlertsModal] = useState(false);
    const [subscribeToAlertsEqquipmentModalOpen, handleToggleSubscribeToEquipmentAlertsModal] = useState(false);
    const [subscribeToAlertsSystemsModalOpen, handleToggleSubscribeToSystemsAlertsModal] = useState(false);
    const [subscribeToRuleAlertsModalOpen, setSubscribeToRuleAlertsModalOpen] = useState(false);

    const [deleteClientModalOpen, handleToggleDeleteClientModal] = useState(false);
    const [deleteSiteModalOpen, handleToggleDeleteSiteModal] = useState(false);
    const [deleteSystemModalOpen, handleToggleDeleteSystemModal] = useState(false);
    const [deleteEquipmentModalOpen, handleToggleDeleteEquipmentModal] = useState(false);
    const [serviceRequestActionModalOpen, handleToggleServiceRequestActionModal] = useState(false);
    const [scheduleModalOpen, handleToggleScheduleModal] = useState(false);
    const [createServiceCallModalOpen, handleToggleCreateServiceCallModal] = useState(false);
    const [createServiceRequest, handleToggleCreateServiceRequest] = useState(false);
    const [subscribeToCompanyModalOpen, setSubscribeToCompanyModalOpen] = useState(false);
    const [exportRawData, setExportRawData] = useState(false);

    const [clientTableProps, setClientTableProps] = useState({});
    const [siteTableProps, setSiteTableProps] = useState({});
    const [equipmentTableProps, setEquipmentTableProps] = useState({});
    const [systemTableProps, setSystemTableProps] = useState({});

    const [searchTerm, setSearchTerm] = useState('');

    const [navModalOpen, setNavModalOpen] = useState(false);

    const [refreshTab, setRefreshTab] = useState('');
    const [exportColumns, setExportColumns] = useState([]);
    const _export = React.useRef(null);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [isexportNodeHealthChecks, setIsexportNodeHealthChecks] = useState(false);

    useEffect(() => {
        const init = async () => {
            await fetchAllConfigurations(userId);
        };

        if (activeNavCompany.name) {
            setPageTitle(activeNavCompany.name, activeTab);
            init();
        }
    }, [activeNavCompany.name]);

    useEffect(() => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        
        let key = queryValues.appId;
            
        if ( queryValues.parentId ) {
            key = queryValues.parentId;
        }

        if ( queryValues.childId ) {
            key = queryValues.childId;
        }

        let activetab = getActiveTabName(key);

        if (activeNavCompany.name) {
            setPageTitle(activeNavCompany.name, activetab);
        }
        
        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
        setSearchTerm('');
        setTimeout(() => {
            setActiveTab(activetab);
        }, 100);
    }, [history.location.search]);

    const getActiveTabTableProps = () => {
        let tableProps = {};

        if (activeTab === 'Client') {
            tableProps = clientTableProps;
        } else if (activeTab === 'Site') {
            tableProps = siteTableProps;
        } else if (activeTab === 'Equipment') {
            tableProps = equipmentTableProps;
        } else if (activeTab === 'System') {
            tableProps = systemTableProps;
        }

        return tableProps;
    };

    const handleExport = event => {
        setExportModalOpen(true);
    };

    const handleHealthMonitorExport = event => {
        const statusColumn = exportColumns.findIndex(c => c.field === 'status');
        const priorityColumn = exportColumns.findIndex(c => c.field === 'priority');
        const issueTypeColumn = exportColumns.findIndex(c => c.field === 'issueTypes');
        const equipmentSystemColumn = exportColumns.findIndex(c => c.field === 'equipmentSystem');
        const routeColumn = exportColumns.findIndex(c => c.field === 'snapshotRoute');
        const faultTimestampColumn = exportColumns.findIndex(c => c.field === 'faulttimestamp');
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach(row => {
            if (row.type === 'data') {
                const statusCell = row.cells[statusColumn];
                const priorityCell = row.cells[priorityColumn];
                const issueTypeCell = row.cells[issueTypeColumn];
                const routeCell = row.cells[routeColumn];
                const equipmentSystemCell = row.cells[equipmentSystemColumn];
                const faultTimestampCell = row.cells[faultTimestampColumn];
                equipmentSystemCell.value = routeCell.value.substring(routeCell.value.lastIndexOf('/') + 1);
                statusCell.value = statusCell.value.toString().toLowerCase() === 'true' ? 'Fault' : 'OK';
                priorityCell.value = priorityCell.value === 0 ? 'Low' : priorityCell.value === 1 ? 'Medium' : 'High';
                issueTypeCell.value = issueTypeCell.value.join(', ');
                faultTimestampCell.value = faultTimestampCell.value ? moment(faultTimestampCell.value).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(faultTimestampCell.value), moment.tz.guess()) : null;
            }
        });
        _export.current.save(options);
    };

    const healthMonitorRawDataExport = event => {
        setIsexportNodeHealthChecks(true);
    };

    const renderTotalsData = activeTab => {
        switch (activeTab) {
            case 'Client':
                return clientsMeta;
            case 'Site':
                return sitesMeta;
            case 'Equipment':
                return equipmentMeta;
            case 'System':
                return systemsMeta;
            case 'Health Monitor':
                return cardScores;
            default:
                return;
        }
    };

    const renderSelectData = activeTab => {
        switch (activeTab) {
            case 'Client':
                return businessTypes;
            case 'Site':
                return buildingTypes;
            case 'Equipment':
                return equipmentTypes;
            case 'System':
                return systemTypes;
            case 'Health Monitor':
                return issueTypes;
            default:
                return [];
        }
    };

    const renderLabel = activeTab => {
        // Both case 2 (equipment) and case 3 (system) use
        // equipment type to describe the entity.
        switch (activeTab) {
            case 'Client':
                return 'Business Types';
            case 'Site':
                return 'Building Types';
            case 'Equipment':
                return 'Equipment Types';
            case 'System':
                return 'System Types';
            case 'Health Monitor':
                return 'Issue Types';
            default:
                return '';
        }
    };

    const selectSetFilter = activeTab => {
        switch (activeTab) {
            case 'Client':
                return setClientFilters;
            case 'Site':
                return setSiteFilters;
            case 'Equipment':
                return setEquipmentFilters;
            case 'System':
                return setSystemFilters;
            case 'Health Monitor':
                return setHealthMonitorFilters;
            default:
                return;
        }
    };

    const handleSetFilter = activeTab => {
        return selectSetFilter(activeTab);
    };

    const activeFilters = {
        'Client':         clientFilters,
        'Site':           siteFilters,
        'Equipment':      equipmentFilters,
        'System':         systemFilters,
        'Health Monitor': healthMonitorFilters
    };
    
    const renderActiveFilters = activeTab => {
        let filters = activeFilters[activeTab] || {};

        return renderFilter(filters);
    };

    const renderChips = activeTab => {
        let filters = activeFilters[activeTab] || {};

        if (isEmpty(filters)) return [];

        return renderChip(filters);
    };

    const handleRemoveFilter = (activeTab, item) => {
        const setFilters = selectSetFilter(activeTab);
        let filters = activeFilters[activeTab];

        removeFilter(setFilters, filters, item);
    };

    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);

        const { pathname } = history.location;
        const { key } = tabView;

        queryValues.childId = key;
        const queryValueString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValueString}`);
    };

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);
    };

    const handleCreateClient = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48&company=${activeNavCompany.id}&entityType=client&parentId=7e71f5d4-9fbf-4710-8601-e1f11e681479`,
                state:    { 'returnUrl': `/v2/dashboard/company?appId=${bob.key}&childId=ccb00d85-7b0c-44ba-bd0e-db216ef1ee46&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4`}
            })
            :
            handleToggleCreateClientModal(true);
    };

    const handleCreateSite = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=7d2489e6-4481-481a-8fbf-d5c0262c6539&company=${activeNavCompany.id}&entityType=site&parentId=7e71f5d4-9fbf-4710-8601-e1f11e681479`,
                state:    { 'returnUrl': `/v2/dashboard/company?appId=${bob.key}&childId=181b15f1-dae9-4258-89ef-07941ff33025&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4` }
            })
            :
            handleToggleCreateSiteModal(true);
    };

    const handleCreateEquipment = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=0da7cfdd-f757-4231-8979-7ff2b806e0a5&company=${activeNavCompany.id}&entityType=equipment&parentId=7e71f5d4-9fbf-4710-8601-e1f11e681479`,
                state:    { 'returnUrl': `/v2/dashboard/company?appId=${bob.key}&childId=1593c439-3150-40b5-a5eb-1328cf5a30be&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4` }
            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const handleCreateSystem = () => {
        process.env.k2aCoreEnabled ?
            setNavModalOpen(true)
            :
            handleToggleCreateEquipmentModal(true);
    };

    const handleGo = () => {
        history.push({
            pathname: `/v2/dashboard/core/entities/manage`,
            search:   `appId=${k2aCore.key}&childId=d0f113f5-32e1-4e2c-bf4d-386edb7f9bc4&client=d4ab2cfd-b3c5-40c7-ac6c-08e977bce69a&company=${activeNavCompany.id}&entityType=system&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b&site=42d3a03d-41ba-4b3c-b155-069b7d20ad3a`,
            state:    { 'returnUrl': `/v2/dashboard/company?appId=${bob.key}&childId=91475757-e1be-4bf3-a228-3be5ef997494&company=${activeNavCompany.id}&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4` }
        });        
    };

    const refreshGrid = () => {
        setRefreshTab(activeTab);
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const handleExportGrid = event => {
        setExportRawData(true);
    };

    return (
        <div className={classes.TableContainer}>
            {
                activeTab === 'Schedule' ?
                    <div className={classes.ServiceRequest}>
                        <SchedulerFilter />
                    </div> :
                    null
            }
            {
                activeTab === 'Energy' || activeTab === 'Service' || activeTab === 'Schedule'? 
                    null :
                    <div
                        className={classes.RefreshContainer}
                        aria-hidden="true"
                        role="button"
                        tabIndex={0}
                        onClick={refreshGrid}
                    >
                        <span className="material-icons-outlined">refresh</span>
                    </div>
            }
            {
                activeTab === 'Service' || activeTab === 'Energy' ? 
                    null :
                    <div className={activeTab === 'Schedule' ? classes.ActionButtonContainer : classes.ActionContainer}>
                        <BobActionMenu
                            activeTab={activeTab}
                            isExport={activeTab !== 'Health Monitor'}
                            handleExport={handleExport}
                            handleHealthMonitorExport={handleHealthMonitorExport}
                            handleCreateSite={() => handleCreateSite()}
                            handleCreateEquipment={() => handleCreateEquipment()}
                            handleCreateSystem={() => handleCreateSystem(true)}
                            handleCreateClient={() => handleCreateClient()}
                            handleCreateServiceCall={() => handleToggleCreateServiceCallModal(true)}
                            handleExportGrid={handleExportGrid}
                            handleToggleCreateServiceRequest={() => handleToggleCreateServiceRequest(true)}
                            handleCreateAppointment={() => handleToggleScheduleModal(true)}
                            handleSubscribeToCompany={() => setSubscribeToCompanyModalOpen(true)}
                            isSchedule={activeTab === 'Schedule'}
                            isHealthMonitor={activeTab === 'Health Monitor'}
                            healthMonitorRawDataExport={healthMonitorRawDataExport}
                        />
                    </div>
            }
            {
                activeTab === 'Client' || activeTab === 'Site' || activeTab === 'Equipment' || activeTab === 'System' || activeTab === 'Health Monitor' ?
                    <div className={classes.TableContainerHead}>
                        <div className={classes.SelectContainer}>
                            <TabViewSelector
                                overviewPage={'company'}
                                activeTab={activeTab}
                                handleChangeView={handleChangetabView}
                            />
                        </div>
                        { activeTab === 'Health Monitor' ? 
                            <div className={classes.SearchContainer}>
                                <SearchInput
                                    key={new Date()}
                                    className={classes.SearchInput}
                                    search={debounce(handleSearch, 700)}
                                    placeholder={`Search by ${activeTab === 'Health Monitor' ? 'Rule' : activeTab} Name`}
                                    value={searchTerm}
                                />
                            </div>
                            : null
                        }
                        <div className={classes.FilterContainer}>
                            {renderChips(activeTab).map((item, index) => (
                                <FilterChip
                                    key={index}
                                    item={item}
                                    removeFilter={() => handleRemoveFilter(activeTab, item)}
                                />
                            ))}
                            { activeTab === 'Health Monitor' ? 
                                <BobFilterComponent
                                    data={renderSelectData(activeTab)}
                                    label={renderLabel(activeTab)}
                                    filterType={TABNAMES[activeTab]}
                                    activeFilters={renderActiveFilters(activeTab)}
                                    setFilters={handleSetFilter(activeTab)}
                                    showStatusFilter={ activeTab === 'Health Monitor' ? true : false}
                                />
                                : null
                            }
                        </div>
                        <div className={classes.TotalsContainer}>
                            {
                                activeTab === 'Client' || activeTab === 'Site' || activeTab === 'System' || activeTab === 'Equipment' ?
                                    <div className={classes.WorkbookModeContainer}>
                                        <BobWorkbookModeButton
                                            handleWorkbookMode={handleWorkbookMode}
                                            workbookMode={workbookModeEnabled}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                (activeTab === 'Client' || activeTab === 'Site') && dashboardIsCurrentTimeStamp ?
                                    <TotalsPanel
                                        data={renderTotalsData(activeTab)}
                                        entityType={`${activeTab}s`}
                                    />
                                    : null
                            }
                        </div>
                    </div>
                    : null
            }
            <div className={classes.GridContainer}>
                { 
                    activeTab === 'Client' ?
                        <ClientsTable
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            totalsData={renderTotalsData(activeTab)}
                            createClientModalOpen={createClientModalOpen}
                            editClientModalOpen={editClientModalOpen}
                            exportRawData={exportRawData}
                            deleteClientModalOpen={deleteClientModalOpen}
                            subscribeToAlertsModalOpen={subscribeToAlertsModalOpen}
                            handleToggleSubscribeToAlertsModal={(value) => handleToggleSubscribeToAlertsModal(value)}
                            handleToggleEditClientModal={(value) => handleToggleEditClientModal(value)}
                            handleToggleCreateClientModal={(value) => handleToggleCreateClientModal(value)}
                            handleToggleDeleteClientModal={(value) => handleToggleDeleteClientModal(value)}
                            refreshTab={refreshTab}
                            setExportRawData={setExportRawData}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setClientTableProps}
                            searchTerm={searchTerm}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                { 
                    activeTab === 'Site' ?
                        <SitesTable
                            activeTab={activeTab}
                            totalsData={renderTotalsData(activeTab)}
                            createSiteModalOpen={createSiteModalOpen}
                            deleteSiteModalOpen={deleteSiteModalOpen}
                            subscribeToAlertsSiteModalOpen={subscribeToAlertsSiteModalOpen}
                            handleToggleSubscribeToSiteAlertsModal={(value) => handleToggleSubscribeToSiteAlertsModal(value)}
                            handleToggleCreateSiteModal={(value) => handleToggleCreateSiteModal(value)}
                            handleToggleDeleteSiteModal={(value) => handleToggleDeleteSiteModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setSiteTableProps}
                            searchTerm={searchTerm}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                { 
                    activeTab === 'Equipment' ?
                        <EquipmentTable
                            activeTab={activeTab}
                            totalsData={renderTotalsData(activeTab)}
                            createEquipmentModalOpen={createEquipmentModalOpen}
                            deleteEquipmentModalOpen={deleteEquipmentModalOpen}
                            subscribeToAlertsEqquipmentModalOpen={subscribeToAlertsEqquipmentModalOpen}
                            handleToggleSubscribeToEquipmentAlertsModal={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                            handleToggleCreateEquipmentModal={(value) => handleToggleCreateEquipmentModal(value)}
                            handleToggleDeleteEquipmentModal={(value) => handleToggleDeleteEquipmentModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setEquipmentTableProps}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                { 
                    activeTab === 'System' ?
                        //<FormulaBuilder />
                        <SystemsTable
                            activeTab={activeTab}
                            totalsData={renderTotalsData(activeTab)}
                            isFromSystemTab={true}
                            createEquipmentModalOpen={createEquipmentModalOpen}
                            deleteSystemModalOpen={deleteSystemModalOpen}
                            subscribeToAlertsSystemsModalOpen={subscribeToAlertsSystemsModalOpen}
                            handleToggleSubscribeToSystemsAlertsModal={(value) => handleToggleSubscribeToSystemsAlertsModal(value)}
                            handleToggleCreateEquipmentModal={(value) => handleToggleCreateEquipmentModal(value)}
                            handleToggleDeleteSystemModal={(value) => handleToggleDeleteSystemModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setSystemTableProps}
                            searchTerm={searchTerm}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                {
                    activeTab === 'Health Monitor' ?
                        <HealthMonitorTable
                            node={{type: 'company', id: activeNavCompany.id}}
                            searchTerm={searchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            healthMonitorFilters={healthMonitorFilters}
                            exportRef={_export}
                            setExportColumns={setExportColumns}
                            exportColumns={exportColumns}
                            setIsexportNodeHealthChecks={setIsexportNodeHealthChecks}
                            isexportNodeHealthChecks={isexportNodeHealthChecks}
                            subscribeToRuleAlertsModalOpen={subscribeToRuleAlertsModalOpen}
                            setSubscribeToRuleAlertsModalOpen={(value) => setSubscribeToRuleAlertsModalOpen(value)}
                        />
                        :
                        null
                }
                {
                    activeTab === 'Energy' ? 
                        <EnergyTable
                            activeTab={activeTab}
                            isActive={true}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        /> 
                        : null
                }
                {
                    activeTab === 'Service' ? 
                        <ServiceRequestList
                            activeTab={activeTab}
                            isFromEntityOverviewpage={true}
                            isActive={true}
                            serviceRequestActionModalOpen={serviceRequestActionModalOpen}
                            createServiceRequest={createServiceRequest}
                            subscribeToAlertsModalOpen={subscribeToAlertsModalOpen}
                            handleToggleSubscribeToAlertsModal={(value) => handleToggleSubscribeToAlertsModal(value)}
                            handleToggleCreateServiceRequest={(value) => handleToggleCreateServiceRequest(value)}
                            handleToggleServiceRequestActionModal={(value) => handleToggleServiceRequestActionModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        />
                        : null
                }
                {
                    activeTab === 'Schedule' ? 
                        <SchedulerDashboard
                            activeTab={activeTab}
                            createServiceCallModalOpen={createServiceCallModalOpen}
                            handleToggleCreateServiceCallModal={(value) => handleToggleScheduleModal(value)}
                            serviceRequestActionModalOpen={scheduleModalOpen}
                            isActive={true}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        />
                        : null
                }     
            </div>
            { isShowExportModal ?
                <BobModal
                    title={''}
                    isOnlyContent={true}
                >
                    <h3>Preparing Export</h3>
                </BobModal> : ''
            }
            {
                navModalOpen ?
                    <NavModal
                        menu={'site'}
                        handleGo={handleGo}
                        setNavModalOpen={setNavModalOpen}
                    />
                    :
                    null
            }
            {
                subscribeToCompanyModalOpen ?
                    <CreateSubscriptionModal
                        parent={activeNavCompany}
                        parentLabel="Company"
                        handleToggleSubscribeToAlertsModal={setSubscribeToCompanyModalOpen}
                    />
                    :
                    null
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={activeNavCompany}
                        setExportModalOpen={setExportModalOpen} 
                        tabView={`Company${TABNAMES[activeTab]}`}
                        tableProps = { getActiveTabTableProps() }
                    /> : ''
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:            state.bob.activeNavCompany,
        buildingTypes:               state.architect.buildingTypes,
        businessTypes:               state.architect.businessTypes,
        cardScores:                  state.home.cardScores,
        clientFilters:               state.dashboard.clientFilters,
        clientsMeta:                 state.dashboard.clientsMeta,
        companyApplications:         state.bob.companyApplications,
        companyTabIndex:             state.dashboard.companyTabIndex,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        equipmentFilters:            state.dashboard.equipmentFilters,
        equipmentMeta:               state.dashboard.equipmentMeta,
        equipmentTypes:              state.equipmentTypes.data,
        healthMonitorFilters:        state.dashboard.healthMonitorFilters,
        isShowExportModal:           state.dashboard.isShowExportModal,
        issueTypes:                  state.svcManagement.issueTypes,
        siteFilters:                 state.dashboard.siteFilters,
        sitesMeta:                   state.dashboard.sitesMeta,
        systemFilters:               state.dashboard.systemFilters,
        systemsMeta:                 state.dashboard.systemsMeta,
        systemTypes:                 state.systemTypes.data,
        userId:                      state.currentUser.id,
        workbookModeEnabled:         state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableContainer));
